/**
 * 基础菜单 商品管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home_page/home_Page' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/map_mn/Map_mn' }">地图管理</el-breadcrumb-item>
      <el-breadcrumb-item>线路管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" style="margin-top: 20px; heigth: 60px">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.name_cn" placeholder="输入线路名称" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-input size="small" v-model="formInline.line_id" placeholder="输入线路编号" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="success" icon="el-icon-plus" @click="importLine"
          v-if="check_auth('/web/line/get_update_line')">更新线路</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row border style="width: 100%">
      <el-table-column prop="id" align="center" label="线路编号" min-width="250">
      </el-table-column>
      <el-table-column prop="name_cn" align="center" label="线路名称" min-width="250">
      </el-table-column>
      <el-table-column prop="station_count" align="center" label="站点数量" min-width="250">
      </el-table-column>
      <el-table-column prop="create_time" align="center" label="创建时间" min-width="250">
      </el-table-column>
      <el-table-column prop="update_time" align="center" label="更新时间" min-width="250">
      </el-table-column>
      <el-table-column prop="status" label="状态" min-width="100" align="center" header-align="center"
        show-overflow-tooltip>
        <template slot-scope="scope">
          <el-switch v-model="scope.row.status" active-color="#13ce66" inactive-color="#e5e5e5"
            @change="changeSwitch(scope.row)"></el-switch>
        </template>
      </el-table-column>
      <el-table-column prop="remark" align="center" label="备注" min-width="300">
      </el-table-column>

      <el-table-column align="center" fixed="right" label="操作" width="300"
        v-if="check_auth('/web/station/get_stations') || check_auth('/web/line/edit_remark') || check_auth('/web/line/del_line')">
        <template slot-scope="scope">
          <el-button plain size="mini" @click="addStation(scope.row)"
            v-if="check_auth('/web/station/get_stations')">站点管理</el-button>
          <el-button size="mini" @click="editLine(scope.row)" v-if="check_auth('/web/line/edit_remark')">编辑</el-button>
          <el-button size="mini" type="danger" @click="delLine(scope.row)"
            v-if="check_auth('/web/line/del_line')">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 更新新路 -->
    <el-dialog title="导入线路" :visible.sync="dialogVisible" width="42%" @click="closeDialog" :destroy-on-close="true"
      :close-on-click-modal="false">
      <el-form :inline="true" :model="form">
        <el-form-item label="线路编号">
          <el-input size="small" v-model="form.id" placeholder="输入线路编号" clearable></el-input>
        </el-form-item>
        <el-form-item label="线路名称">
          <el-input size="small" v-model="form.name_cn" placeholder="输入线路名称" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="searchLine">搜索</el-button>
        </el-form-item>
      </el-form>

      <el-table :data="gridData" @selection-change="handleSelectionChange" ref="multipleTable" row-key="id">
        <el-table-column type="selection" reserve-selection align="center" width="55">
        </el-table-column>

        <el-table-column property="id" label="线路编号" align="center" min-width="200"></el-table-column>
        <el-table-column property="name_cn" label="线路名称" align="center" min-width="200"></el-table-column>
        <el-table-column property="station_count" align="center" min-width="150" label="站点数量"></el-table-column>
        <el-table-column label="操作" width="150" align="center">
          <template slot-scope="scope">
            <el-button type="mini" round @click="showmap(scope.row)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="block">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="pageLine.currentPage" :page-sizes="[10, 15, 25, 50, 100]" :page-size="pageLine.pageSize"
          background :pager-count="5" layout="total, sizes, prev, pager, next, jumper" :total="pageLine.total">
        </el-pagination>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取 消</el-button>
        <el-button type="primary" @click="addImport">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 编辑界面 -->
    <el-dialog :visible.sync="editFormVisible" width="35%" title="修改" @click="closeDialog" :destroy-on-close="true"
      :close-on-click-modal="false">
      <el-form label-width="85px" :model="editForm" :rules="rules" ref="editForm">
        <el-form-item label="线路编号" prop="line_id">
          <el-input size="small" v-model="editForm.id" auto-complete="off" :disabled="true" placeholder="请输入线路编号">
          </el-input>
        </el-form-item>
        <el-form-item label="线路名称" prop="name_cn">
          <el-input size="small" v-model="editForm.name_cn" auto-complete="off" :disabled="true" placeholder="请输入线路名称">
          </el-input>
        </el-form-item>
        <el-form-item label="站点数量" prop="station_count">
          <el-input size="small" v-model="editForm.station_count" auto-complete="off" :disabled="true"
            placeholder="请输入站点数量"></el-input>
        </el-form-item>
        <el-form-item label="创建时间" prop="create_time">
          <el-input size="small" v-model="editForm.create_time" auto-complete="off" :disabled="true"
            placeholder="请输入创建时间"></el-input>
        </el-form-item>
        <el-form-item label="更新时间" prop="update_time">
          <el-input size="small" v-model="editForm.update_time" auto-complete="off" :disabled="true"
            placeholder="请输入更新时间"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input size="small" type="textarea" rows="3" v-model="editForm.remark" auto-complete="off"
            placeholder="请输入备注">
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="editFormVisible = false">取消</el-button>
        <el-button size="small" type="primary" class="title" @click="submitForm('editForm')">保存</el-button>
      </div>
    </el-dialog>
    <!-- 地图管理 -->
    <el-dialog title="地图" :visible.sync="dialogTableVisible" width="40%" @click="closeDialog" :destroy-on-close="true"
      :close-on-click-modal="false">
      <div id="container"></div>
    </el-dialog>
  </div>
</template>

<script>
let conmap = "";
import {
  get_line_list,
  get_one_line,
  get_line_edit,
  get_switch_status,
  get_del_line,
  get_update_line,
  get_import_lines,
  get_update_line_detail,
} from "../../api/line/line";
import { auth } from "../../utils/util";
import Pagination from "../../components/Pagination";
export default {
  data() {
    return {
      nshow: true, //switch开启
      fshow: false, //switch关闭
      editFormVisible: false, //控制编辑页面显示与隐藏
      dialogVisible: false,
      dialogTableVisible: false,
      idsval: [],
      ids: [],
      value: true,
      gridData: [],
      listData: [],
      editForm: {
        id: "",
        name: " ",
        name_cn: "",
        station_count: "",
        create_time: " ",
        update_time: " ",
        remark: " ",
      },
      form: {
        id: "",
        name_cn: "",
        page: 1,
        limit: 10,
      },
      // rules表单验证
      rules: {
        id: [{ required: true, message: "请输入线路编号", trigger: "blur" }],
        name_cn: [
          { required: true, message: "请输入线路名称", trigger: "blur" },
        ],
        station_count: [
          { required: true, message: "请输入站点数量", trigger: "blur" },
        ],
        create_time: [
          { required: true, message: "请输入创建时间", trigger: "blur" },
        ],
        update_time: [
          { required: true, message: "请输入更新时间", trigger: "blur" },
        ],
        remark: [{ required: true, message: "请输入备注", trigger: "blur" }],
      },
      formInline: {
        page: 1,
        limit: 10,
        name_cn: "",
        line_id: "",
      },
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10,
      },
      pageLine: {
        currentPage: 1,
        pageSize: 10,
        total: 10,
      },
    };
  },
  // 注册组件
  components: {
    Pagination,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getData();
  },
  mounted() { },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    async getCreateMap(row) {
      return get_update_line_detail(row.id).then((res) => {
        if (res["code"] === 0) {
          this.linePath = res.data;
        }
      });
    },
    check_auth(val) {
      return auth(val);
    },
    // 地图
    async showmap(row) {
      this.dialogTableVisible = true;
      await this.getCreateMap(row);
      //创建地图
      setTimeout(() => {
        conmap = new AMap.Map("container", {
          resizeEnable: true, //是否监控地图容器尺寸变化
          zoom: 25, //初始化地图层级
          center: [118.054994, 36.813787], //初始化地图中心点
        });

        this.guiji();
      }, 100);
    },
    guiji() {
      let a = [];
      let lnglat = [];
      let _path = [];
      a = this.linePath;

      for (let i = 0; i < a.length; i++) {
        lnglat.push(new AMap.LngLat(parseFloat(a[i]["lon"]), parseFloat(a[i]["lat"])));
      }
      AMap.convertFrom(lnglat, 'gps', function (status, result) {
        if (result.info === 'ok') {
          var resLnglat = result.locations;
          for (let i = 0; i < resLnglat.length; i++) {
            _path.push([resLnglat[i].lng, resLnglat[i].lat]);
          }
          AMapUI.load(
            ["ui/misc/PathSimplifier", "lib/$"],
            function (PathSimplifier, $) {
              if (!PathSimplifier.supportCanvas) {
                alert("当前环境不支持 Canvas！");
                return;
              }

              var pathSimplifierIns = new PathSimplifier({
                zIndex: 10,
                //autoSetFitView:false,
                map: conmap, //所属的地图实例

                getPath: function (pathData, pathIndex) {
                  return pathData.path;
                },
                getHoverTitle: function (pathData, pathIndex, pointIndex) {
                  if (pointIndex >= 0) {
                    //point
                    return (
                      pathData.line_name +
                      "，点：" +
                      pointIndex +
                      "/" +
                      pathData.path.length
                    );
                  }

                  return pathData.line_name + "，点数量" + pathData.path.length;
                },
                renderOptions: {
                  renderAllPointsIfNumberBelow: 100, //绘制路线节点，如不需要可设置为-1
                },
              });
              window.pathSimplifierIns = pathSimplifierIns;

              //设置数据

              pathSimplifierIns.setData([
                {
                  line_name: "路线0",
                  path: _path,
                },
              ]);

              //对第一条线路（即索引 0）创建一个巡航器
              var navg1 = pathSimplifierIns.createPathNavigator(0, {
                loop: true, //循环播放
                speed: 100, //巡航速度，单位千米/小时
              });

              navg1.start();
            }
          );
        }
      });
    },
    //跳转到线路管理0
    addStation(row) {
      window.localStorage.setItem("line_id", row.id);
      this.$router.push("/map_mn/Station_mn");
    },
    // 获取公司列表
    getData() {
      window.localStorage.removeItem("line_id");
      get_line_list(this.formInline).then((res) => {
        if (res["code"] === 0) {
          this.listData = res.data.data;
          for (var i = 0; i < this.listData.length; i++) {
            this.listData[i].status =
              this.listData[i].status === 1 ? true : false;
          }
          this.pageparm.currentPage = this.formInline.page;
          this.pageparm.pageSize = this.formInline.limit;
          this.pageparm.total = res.data["total"];
        }
      });
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage;
      this.formInline.limit = parm.pageSize;
      this.getData();
    },
    // 搜索事件
    search() {
      this.formInline.page = 1;
      this.getData();
    },
    // 导入线路列表
    getImport() {
      get_update_line(this.form).then((res) => {
        if (res["code"] === 0) {
          // this.loading = false;
          this.gridData = res.data.data;
          this.pageLine.currentPage = this.form.page;
          this.pageLine.pageSize = this.form.limit;
          this.pageLine.total = res.data["total"];
        }
      });
    },
    // 分页插件事件
    callLine() {
      this.form.page = this.pageLine.currentPage;
      this.form.limit = this.pageLine.pageSize;
      this.getImport();
    },
    // 搜索事件
    searchLine() {
      this.form.page = 1;
      this.getImport();
    },
    // 显示导入线路界面
    importLine() {
      this.dialogVisible = true;
      this.form.id = "";
      this.form.name_cn = "";
      this.form.page = 1;
      this.getImport();
      this.toggleRowSelect();
    },
    //导入车辆id
    handleSelectionChange(val) {
      this.idsval = [];
      for (let i in val) {
        //去重以免发生意外的push
        if (!this.idsval.includes(val[i])) {
          this.idsval.push(val[i]);
        }
      }
    },
    toggleRowSelect() {
      var that = this;
      that.$nextTick(() => {
        if (that.$refs.multipleTable) {
          that.$refs.multipleTable.clearSelection();
        }
      });
    },
    //导入数据
    addImport() {
      this.dialogVisible = false;
      for (var i = 0; i < this.idsval.length; i++) {
        this.ids.push(this.idsval[i].id);
      }
      var strs = this.ids.join(",");
      get_import_lines(strs).then((res) => {
        if (res["code"] === 0) {
          this.getData();
          this.$message.success(res["message"]);
          this.ids = [];
        }
      });
    },
    //显示编辑界面
    editLine(row) {
      this.editFormVisible = true;
      get_one_line(row.id).then((res) => {
        if (res["code"] === 0) {
          this.editForm = res.data;
        }
      });
    },
    // 修改线路信息
    submitForm(editData) {
      this.$refs[editData].validate((valid) => {
        if (valid) {
          get_line_edit(this.editForm).then((res) => {
            this.editFormVisible = false;
            this.loading = false;
            if (res["code"] === 0) {
              this.getData();
              this.editForm = {};
              this.$message.success(res["message"]);
            }
          });
        } else {
          return false;
        }
      });
    },
    //修改状态
    changeSwitch(row) {
      get_switch_status(row.id, row.status ? 1 : 0).then((res) => {
        if (res["code"] === 0) {
          this.getData();
          this.$message.success(res["message"]);
        }
      });
    },
    // 删除线路
    delLine(row) {
      this.$confirm("确定要删除吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          get_del_line(row.id).then((res) => {
            if (res["code"] === 0) {
              this.$message.success(res["message"]);
              if (this.listData.length === 1) {
                if (this.formInline.page === 1) {
                  this.getData();
                } else {
                  this.formInline.page = this.formInline.page - 1;
                  this.getData();
                }
              } else {
                this.getData();
              }
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    handleSizeChange(val) {
      this.pageLine.pageSize = val;
      this.callLine();
    },
    handleCurrentChange(val) {
      this.pageLine.currentPage = val;
      this.callLine();
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false;
      this.dialogVisible = false;
      conmap.destroy();
    },
  },
};
</script>

<style scoped>
#container {
  width: 100%;
  height: 600px;
}

.userRole {
  width: 100%;
}
</style>

 
 


// WEBPACK FOOTER //
// src/views/map_mn/Line_mn.vue